<template>
    <div class="mc-tips" v-show="showTips">
        <p @click="toLink"><font>前往<span>河北日报</span> 客户端才可参与活动哦~</font></p> 
        <span class="close-mc" @click="closeTips">关闭提醒</span>
    </div>
</template>

<script>

import jump2hbrb from '@/utils/jump2app-hb.js'

export default {
  name:'tips',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
        showTips:true,
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted() {
    this.checkTips()
  },
  methods: {
    checkTips() {
        if (/(hbxw)/i.test(navigator.userAgent)) {
            this.showTips = false;
        } else {
            this.showTips = true;
        }
    },
    toLink() {
        jump2hbrb.toMLink(window.location.href)
    },
    closeTips() {
        this.showTips = false;
    }
  },
}
</script>
<style scoped>

/* 页面顶部日报客户端下载提示 */
.mc-tips {position: fixed; z-index: 999; top: 0; width: 750px; height: 60px; background-color: rgba(74,74,74,.8); line-height: 60px; font-size: 26px; font-weight: 300; display: flex; align-items: center; }
.mc-tips p { color: #fff; width: 80%!important; min-height: 100%; padding: 0px; margin: 0px; text-align: center;}
.mc-tips p span {color: #e8a211;}
.mc-tips .close-mc { width: 20%; height: 100%; display: flex; align-items: center; justify-content: center; color: #4990e2;}

/*字数滚动*/
.mc-tips p { width: 300px; height:60px; display: flex; align-items: center; font-size: 26px; margin: 0 auto; white-space: nowrap; /*文字不折行*/ overflow: hidden; /*文字溢出隐藏*/ }
.mc-tips p font{ display: inline-block;/*inline样式不能使用动画*/ animation: scroll 15s linear infinite; /*滚动动画*/ font-size: 26px; font-weight: 300; line-height: 60px;}       
@keyframes scroll {
    from {
        transform: translateX(300px); /*div多宽就写多宽*/
    }
    to {
        transform: translateX(-100%);
    }
} 
</style>
